import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Image from 'components/Image'
import MainImage from 'public/img/main-image-blog.jpeg'
import usePageProps from 'hooks/usePageProps'
import Container from '@mui/material/Container'
import sx from './styles'

const MainBanner = () => {
  const { categories } = usePageProps()

  const categoryCard = (category) => {
    return (
      <>
        <Box
          sx={sx.icon}
          className={category?.slug}
        >
          <Image
            src={category?.icon}
            height={25}
            width={25}
            layout="fill"
          />
        </Box>
        <Box sx={sx.text}>
          {category.name}
        </Box>
      </>
    )
  }

  return (
    <Container
      maxWidth={false}
      sx={sx.root}
    >
      <Grid
        item
        container
        xs={12}
        lg={11}
        justifyContent="center"
        spacing={2}
        alignItems="center"
        sx={sx.container}
      >
        <Grid
          item
          xs={12}
          lg="auto"
          sx={sx.imageContainer}
        >
          <Image
            src={MainImage}
            layout="fill"
            objectFit="cover"
            sx={sx.mainImage}
          />

        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
        >
          <Box>
            <Typography variant="h1">
              <FormattedMessage id="BLOG_MAIN_TITLE" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="BLOG_MAIN_DESCRIPTION" />
            </Typography>
          </Box>
          <Box mt={4}>
            <Typography variant="subtitle1">
              <FormattedMessage id="BLOG_DIFFERENTS_XPERIENCES" />
            </Typography>
          </Box>
          <Grid
            item
            container
            mt={1}
            xs={12}
            spacing={2}
          >
            {categories?.map((category) => (
              <Grid
                item
                xs={6}
                sm={4}
                sx={sx.categories}
              >
                {categoryCard(category)}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>

  )
}

export default memo(MainBanner)
